export default __webpack_public_path__ + "static/media/image-template.21336b26.svg";